
import ApontamentoHeaderReportSemImplemento from "entity/Indicador/reports/ApontamentoHeaderReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";

export default async function apontamentoReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        // const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo);
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)

        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);
        const hP = new TableReportHelper(apontamento);
        content.push([
            ApontamentoHeaderReportSemImplemento(visita, indicador, apontamento, params, "Intervalo (Dias)"),
            hP.panel(
                [
                    hP.row(
                        hP.title("Data Preparo de Solo"),
                        hP.title("Data Início do Plantio"),
                    ),

                    hP.row(

                        hP.dateField("dataPreparoSolo"),
                        hP.dateField("dataInicioPlantio"),

                    ),
                ],
                { widths: ["*", "*"] }
            ),

            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "Dias"),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
